import CampaignComponents from './CampaignComponents.vue'

export default CampaignComponents
